import React from 'react';
import PropTypes from 'prop-types';
import { FeaturesProvider } from '@nextiva/feature-toggle';
import App from './App';

const AppContainer = ({ globalStoreData }) => {
  if (globalStoreData.isLoading) {
    return null;
  }

  const { user, sso, impersonation } = globalStoreData;
  const isZeroTrust = impersonation?.impersonation === false;

  return (
    <FeaturesProvider user={user} ssoToken={sso} isZeroTrust={isZeroTrust}>
      <App globalStoreData={globalStoreData} />
    </FeaturesProvider>
  );
};

AppContainer.propTypes = {
  globalStoreData: PropTypes.object.isRequired,
};

AppContainer.defaultProps = {
  globalStoreData: {},
};

export default AppContainer;
